import React from "react";
import "./Header.css";
import img from "./Assets/download.png";
import SearchIcon from "@material-ui/icons/Search";
import ShoppingCartIcon from "@material-ui/icons/ShoppingCart";
import { Link, useHistory } from "react-router-dom";
import { useStateValue } from "./StateProvider";
import { auth } from "./firebase";
function Header() {
  const history = useHistory();
  const [state, dispatch] = useStateValue();
  const handleAuthentication = () => {
    if (state.user) {
      auth
        .signOut()
        .then(() => {
          history.push("/");
        })
        .catch((error) => {
          alert(error);
        });
    }
  };

  return (
    <div className="header">
      <Link to="/">
        <img className="header_logo" src={img} />
      </Link>
      <div className="header_search">
        <input className="header_searchinput" type="text"></input>
        <SearchIcon className="header_searchicon" />
      </div>
      <div className="header_nav">
        <Link to="/signin">
          <div onClick={handleAuthentication} className="header_option">
            <span className="header_optionone">Hello</span>
            <span className="header_optiontwo">
              {state.user ? "Sign Out" : "Sign In "}
            </span>
          </div>
        </Link>
        <div className="header_option">
          <span className="header_optionone">Returns</span>
          <span className="header_optiontwo">& Orders</span>
        </div>
        <div className="header_option">
          <span className="header_optionone">Your</span>
          <span className="header_optiontwo">Prime</span>
        </div>
      </div>
      <Link to="/checkout">
        <div className="header_basket">
          <ShoppingCartIcon></ShoppingCartIcon>
          <span className="header_optiontwo  header_basketcount">
            {state.basket?.length}
          </span>
        </div>
      </Link>
    </div>
  );
}
export default Header;
